module.exports = __webpack_public_path__ + "img/avatar6.f1fb9659.png";